/* Copyright (c) 2020-present CloudIO Inc */

import { Slider, SliderProps, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { memo } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
    position: 'relative',
  },
  label: {
    flex: 0,
    minWidth: 80,
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
  },
  slider: {
    flex: 2,
    height: '30px',
    overflow: 'visible',
    padding: '0 8px',
  },
  input: {
    border: `4px solid ${theme.palette.background.default}`,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    lineHeight: '22px',
    padding: 0,
    textAlign: 'end',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '80px',
    width: '80px',
  },
  tip: {
    marginLeft: 8,
  },
}));

export type NumberSliderProps = SliderProps;
function NumberSlider(props: NumberSliderProps) {
  const classes = useStyles();
  const { value, min, max, step, onChange, disabled } = props;

  return (
    <div className={classes.inner}>
      <div className={classes.slider}>
        <Slider
          valueLabelDisplay="auto"
          step={step}
          min={min}
          disabled={disabled}
          max={max}
          onChange={(_: Event, val: number | number[], activeThumb: number) => {
            if (typeof val === 'number' && onChange) {
              onChange(_, val, activeThumb);
            }
          }}
          value={value}
        />
      </div>
      <input
        type="number"
        disabled={disabled}
        className={classes.input}
        value={value as number}
        onChange={(e) => {
          if (e.target.value && onChange) {
            onChange(e as unknown as Event, Number(e.target.value), 0);
          }
        }}
        min={min}
        max={max}
      />
    </div>
  );
}

export default memo(NumberSlider);
